import { SubText } from '@procurify/ui'

import { OrderItemStatusLabel } from '@webapp/components/OrderItemStatusLabel'
import { PunchOutStatusLabel } from '@webapp/components/PunchOutStatusLabel'
import { type PunchOutStatus, PunchOutStatuses } from '@webapp/models/enums'
import { type ColumnTypeData } from '../../types/DataTable.types'

const punchoutItemNeedsAttention = (status: PunchOutStatus): boolean => {
  return (
    status &&
    [
      PunchOutStatuses.ORDER_CANCELLED,
      PunchOutStatuses.PARTIALLY_PURCHASED,
      PunchOutStatuses.BACKORDERED,
    ].includes(status)
  )
}

export const OrderItemStatusCell = ({
  punchOutStatus,
  isPunchOutSystem,
  itemStatus,
  purchaseOrderNumber,
  submittedDate,
  showOrderConfirmationWarning,
  isFailedPunchoutOrder = false,
}: ColumnTypeData['ORDERITEM_STATUS']) => {
  const showPunchOutItemNeedsAttentionLabel =
    isPunchOutSystem &&
    (punchoutItemNeedsAttention(punchOutStatus) || isFailedPunchoutOrder)

  return showPunchOutItemNeedsAttentionLabel ? (
    <PunchOutStatusLabel
      status={punchOutStatus}
      isFailedPunchoutOrder={isFailedPunchoutOrder}
      submittedDate={submittedDate}
    >
      {(textProps) => <SubText {...textProps} />}
    </PunchOutStatusLabel>
  ) : (
    <OrderItemStatusLabel
      status={itemStatus}
      purchaseOrderNumber={purchaseOrderNumber}
      showOrderConfirmationWarning={showOrderConfirmationWarning}
    >
      {(textProps) => <SubText {...textProps} />}
    </OrderItemStatusLabel>
  )
}

OrderItemStatusCell.displayName = 'OrderItemStatusCell'
